module.exports = __webpack_public_path__ + "6864651ec620d1917c10a554d55825a7.svg";